import React, { Component } from "react";
import { translations } from "../../containers/assets/translations";
import { B2B_PROXY } from "../../containers/assets/config";
import {
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Col,
  Row,
  Table,
} from "react-bootstrap";
import Modal from "react-responsive-modal";
import axios from "axios";
import moment from "moment";
import { ToastStore } from "react-toasts";

class PassengerDetailsPlaceholder extends Component {
  render() {
    const {
      t,
      details = [],
      onRemove,
      onEditPassenger,
      passengerInput,
      onInputChange,
      onAddPassenger,
      Countries = [],
      isView,
      canCreate,
      canUseMRZ,
      scannedSuccessfully,
    } = this.props;

    const inputMethod = passengerInput.inputMethod;
    const isMRZ = inputMethod === "MRZ";
    const today = moment().format("YYYY-MM-DD");

    // Logic: If the user cannot create, they shouldn't see the input fields
    // unless they are explicitly in "View" mode which is already handled.
    const showInputs = !isView && canCreate;

    // Helper to render inputs with conditional green border
    const renderPassengerInput = (
      label,
      name,
      value,
      type = "text",
      required = false,
      min = null,
      max = null
    ) => (
      <Col md={isMRZ ? 0 : 2} style={{ display: isMRZ ? "none" : "block" }}>
        <FormGroup>
          <ControlLabel>{t[label]}</ControlLabel>
          <FormControl
            className={scannedSuccessfully ? "well success-border" : "well"}
            type={type}
            name={name}
            value={value}
            onChange={onInputChange}
            required={required}
            min={min}
            max={max}
          />
        </FormGroup>
      </Col>
    );

    return (
      <div className="passenger-details-section">
        <br />
        <h6>{t["Passenger/Vehicle Manifest"]}</h6>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>{t["Surname"]}</th>
              <th>{t["Name"]}</th>
              <th>{t["Gender"]}</th>
              <th>{t["Birth Date"]}</th>
              <th>{t["Nationality"]}</th>
              <th>{t["Passport"]}</th>
              <th>{t["Passport Expiry Date"]}</th>
              {!isView && <th>{t["Action"]}</th>}
            </tr>
          </thead>
          <tbody>
            {details.map((item, index) => (
              <tr key={index}>
                <td>{item.surname}</td>
                <td>{item.name}</td>
                <td>{item.gender}</td>
                <td>{item.birthDate}</td>
                <td>{item.nationality}</td>
                <td>{item.passportNumber}</td>
                <td>{item.passportExpirationDate}</td>
                {!isView && (
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        title={t["Edit Passenger"]}
                        style={{ cursor: "pointer", display: "inline-flex" }}
                        onClick={() => onEditPassenger(item, index)}
                      >
                        <svg
                          width="18px"
                          height="18px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11 4H4C2.89543 4 2 4.89543 2 6V20C2 21.1046 2.89543 22 4 22H18C19.1046 22 20 21.1046 20 20V13M18.5 2.5C19.8807 1.11929 22.1193 1.11929 23.5 2.5C24.8807 3.88071 24.8807 6.11929 23.5 7.5L11.8473 19.1527L9 20L9.84731 17.1527L21.5 5.5"
                            stroke="#204385"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>

                      {!item.passengerId && (
                        <span
                          style={{
                            color: "red",
                            cursor: "pointer",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                          onClick={() => onRemove(item, index)}
                        >
                          {t["Remove"]}
                        </span>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
            {details.length === 0 && (
              <tr>
                <td colSpan={isView ? "7" : "8"} className="text-center">
                  {t["No manifest details added"]}
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {showInputs && (
          <React.Fragment>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <label className="radio-inline">
                    <input
                      type="radio"
                      name="inputMethod"
                      value="Manual"
                      checked={inputMethod === "Manual"}
                      onChange={onInputChange}
                    />
                    {t["Manual"]}
                  </label>
                  {canUseMRZ && (
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="inputMethod"
                        value="MRZ"
                        checked={inputMethod === "MRZ"}
                        onChange={onInputChange}
                      />
                      {t["MRZ"]}
                    </label>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                {renderPassengerInput(
                  "Surname",
                  "surname",
                  passengerInput.surname,
                  "text",
                  true
                )}
                {renderPassengerInput(
                  "Name",
                  "name",
                  passengerInput.name,
                  "text",
                  true
                )}

                <Col
                  md={isMRZ ? 0 : 1}
                  style={{ display: isMRZ ? "none" : "block" }}
                >
                  <FormGroup>
                    <ControlLabel>{t["Gender"]}</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="gender"
                      className={scannedSuccessfully ? "success-border" : ""}
                      value={passengerInput.gender}
                      onChange={onInputChange}
                    >
                      <option value="">--</option>
                      <option value="M">M</option>
                      <option value="F">F</option>
                    </FormControl>
                  </FormGroup>
                </Col>

                {renderPassengerInput(
                  "Birth Date",
                  "birthDate",
                  passengerInput.birthDate,
                  "date",
                  false,
                  null,
                  today
                )}

                <Col
                  md={isMRZ ? 0 : 2}
                  style={{ display: isMRZ ? "none" : "block" }}
                >
                  <FormGroup>
                    <ControlLabel>{t["Nationality"]}</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="nationality"
                      className={scannedSuccessfully ? "success-border" : ""}
                      value={passengerInput.nationality}
                      onChange={onInputChange}
                    >
                      <option value="">Select...</option>
                      {Countries.map((c, i) => (
                        <option key={i} value={c.ThreeLtrCode}>
                          {c.Name}
                        </option>
                      ))}
                    </FormControl>
                  </FormGroup>
                </Col>

                {renderPassengerInput(
                  "Passport",
                  "passportNumber",
                  passengerInput.passportNumber
                )}
                {renderPassengerInput(
                  "Passport Expiry Date",
                  "passportExpirationDate",
                  passengerInput.passportExpirationDate,
                  "date",
                  false,
                  today
                )}

                <Col md={10} style={{ display: isMRZ ? "block" : "none" }}>
                  <FormGroup>
                    <ControlLabel>{t["MRZ Data"]}</ControlLabel>
                    <FormControl
                      componentClass="textarea"
                      name="mrzRaw"
                      rows={3}
                      value={passengerInput.mrzRaw || ""}
                      onChange={onInputChange}
                      placeholder={t["Paste MRZ here..."]}
                    />
                  </FormGroup>
                </Col>

                <Col md={2} className="text-right">
                  <FormGroup style={{ marginTop: "18px" }}>
                    <Button
                      style={{
                        backgroundColor: "#555",
                        color: "white",
                        border: "none",
                      }}
                      onClick={onAddPassenger}
                    >
                      {t["Add"]}
                    </Button>
                  </FormGroup>
                </Col>
              </Col>
            </Row>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default class BGRCreateEditModal extends Component {
  constructor(props) {
    super(props);
    const initialData = props.listData || {};
    const travelMoment = initialData.travelDate
      ? moment(initialData.travelDate)
      : moment();

    let isView = !!initialData.isView;
    if (initialData.status === "CLOSED" || initialData.status === "REJECTED")
      isView = true;
    if (initialData.status === "SUBMITTED" && initialData.moreOneTime === true)
      isView = true;

    this.state = {
      isEdit: !!props.listData,
      isView: isView,
      loading: false,
      scannedSuccessfully: false,
      Countries: [],
      reservationId:
        initialData.reservationId || Math.random().toString().substring(2, 8),
      reservationNumber: initialData.reservationNumber,
      pcsReservation: initialData.pcsReservation || "",
      transportCompany: initialData.transportCompany || "",
      travelDateOnly: travelMoment.format("YYYY-MM-DD"),
      travelTimeOnly: travelMoment.format("HH:mm"),
      licensePlate: initialData.licensePlate || "",
      manifestDetails: initialData.passengers || [],
      passengerInput: {
        surname: "",
        name: "",
        gender: "",
        birthDate: "",
        nationality: "",
        passportNumber: "",
        passportExpirationDate: "",
        inputMethod: "Manual",
        mrzRaw: "",
      },
    };
    this.isUnmounted = false;
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  componentDidUpdate(prevProps) {
    if (this.props.lastScannedMRZ && 
        (!prevProps.lastScannedMRZ || this.props.lastScannedMRZ.timestamp !== prevProps.lastScannedMRZ.timestamp)) {
      this.processCleanData(this.props.lastScannedMRZ.data);
    }
  }

  componentDidMount() {
    this.getCountries();
    // Only check serial connection if user can create
    if (this.props.canCreate) {
      this.checkExistingConnection();
    }
  }


  getCountries = () => {
    axios
      .get(B2B_PROXY + "/Countries")
      .then((res) => {
        const CountriesMap = res.data.map((obj) => ({
          Code: obj.Code,
          ThreeLtrCode: obj.ThreeLtrCode,
          Name: obj.Name,
        }));
        this.setState({ Countries: CountriesMap });
      })
      .catch((err) => console.error("Error fetching countries", err));
  };

  checkExistingConnection = async () => {};

  connectSerialDevice = async () => {
    this.props.onRequestPort();
  };

  startReading = async () => {};

  processCleanData = (data) => {
    const cleanedData = data.replace(/[\x00-\x1F\x7F-\x9F]/g, "").trim();
    if (cleanedData.length > 40 && cleanedData.includes("<<")) {
      this.parseData(cleanedData);
    }
  };

  parseData = (rawData) => {
    // 1. Clean whitespace and find the start of ANY document MRZ
    // IDs can start with I, A, or C. Passports start with P.
    let mrz = rawData.replace(/\s/g, "");

    // Search for the start pattern: Letter + < (e.g., P<, I<, A<, C<)
    const match = mrz.match(/[PIAC][<]/);
    if (!match) return;

    const startIdx = match.index;
    mrz = mrz.substring(startIdx);

    // 2. Identify line length (Standard MRZ is 44, IDs are often 30 or 36)
    // Most passport scanners output 44 chars per line.
    const lineLength = 44;
    const line1 = mrz.substring(0, lineLength);
    const line2 = mrz.substring(lineLength, lineLength * 2);

    if (line1.length < lineLength || line2.length < lineLength) return;

    // 3. Updated helper to handle Birth vs Expiry logic
    const formatMRZDate = (dateStr, isExpiry = false) => {
      if (!dateStr || dateStr.length < 6) return "";
      const year = parseInt(dateStr.substring(0, 2));
      const month = dateStr.substring(2, 4);
      const day = dateStr.substring(4, 6);

      let century = "";
      if (isExpiry) {
        // Expiry dates are almost always in the future (2000s)
        // Only if the year is very high (e.g., > 70) would we suspect 1900s
        century = year > 70 ? "19" : "20";
      } else {
        // Birth date logic: If YY > current year (e.g., 85 > 26), it's 1900s
        const currentYearYY = new Date().getFullYear() - 2000;
        century = year > currentYearYY ? "19" : "20";
      }

      return `${century}${year}-${month}-${day}`;
    };

    // 4. Extract Names
    // Skip the first 5 chars (Type, Country, Doc Number parts)
    const namePart = line1.substring(5);
    const names = namePart.split("<<");
    const surname = names[0] ? names[0].replace(/</g, " ").trim() : "";
    const firstName = names[1] ? names[1].replace(/</g, " ").trim() : "";

    // 5. Extract Gender and Dates from Line 2
    // Line 2 indices: 0-9 DocNum, 13-19 Birth, 20 Gender, 21-27 Expiry
    const rawGender = line2.substring(20, 21).toUpperCase();
    const genderValue = rawGender === "M" || rawGender === "F" ? rawGender : "";

    const nationalityCode = line1.substring(2, 5).replace(/</g, "");
    const mappedCountry = this.state.Countries.find(
      (c) => c.ThreeLtrCode === nationalityCode
    );
    const finalNationality = mappedCountry ? mappedCountry.Code : nationalityCode;

    this.setState({
      scannedSuccessfully: true,
      passengerInput: {
        surname: surname,
        name: firstName,
        gender: genderValue,
        // Birth Date uses default logic (checks against current year)
        birthDate: formatMRZDate(line2.substring(13, 19), false),
        nationality: finalNationality,
        passportNumber: line2.substring(0, 9).replace(/</g, "").trim(),
        // Expiry Date uses isExpiry = true (forces 2000s for foreseeable dates)
        passportExpirationDate: formatMRZDate(line2.substring(21, 27), true),
        inputMethod: "Manual",
        mrzRaw: "",
      },
    });
  };

  handlePassengerInputChange = (e) => {
    const { name, value } = e.target;
    // Detect keyboard emulation dump
    if (value.length > 40 && value.includes("<<")) {
      this.processCleanData(value);
      return;
    }
    this.setState((prev) => ({
      scannedSuccessfully: false, // Reset border on manual edit
      passengerInput: { ...prev.passengerInput, [name]: value },
    }));
  };

  handleEditPassenger = (item, index) => {
    this.setState({
      passengerInput: { ...item, inputMethod: "Manual" },
      manifestDetails: this.state.manifestDetails.filter((_, i) => i !== index),
      scannedSuccessfully: false,
    });
  };

  handleAddPassenger = () => {
    const { passengerInput, manifestDetails } = this.state;
    const t = translations[this.props.lang] || translations["EN"];
    if (manifestDetails.length >= 20)
      return ToastStore.error(
        t["A reservation cannot have more than 20 passengers."]
      );
    if (
      (!passengerInput.surname || !passengerInput.name) &&
      passengerInput.inputMethod !== "MRZ"
    ) {
      return ToastStore.warning(t["Required fields missing"]);
    }
    this.setState((prev) => ({
      manifestDetails: [...prev.manifestDetails, { ...passengerInput }],
      scannedSuccessfully: false,
      passengerInput: {
        surname: "",
        name: "",
        gender: "",
        birthDate: "",
        nationality: "",
        passportNumber: "",
        passportExpirationDate: "",
        inputMethod: "Manual",
        mrzRaw: "",
      },
    }));
  };

  onRemove = (item, index) => {
    this.setState((prev) => ({
      manifestDetails: prev.manifestDetails.filter((_, i) => i !== index),
    }));
  };

  processSave = () => {
    const {
      manifestDetails,
      reservationId,
      reservationNumber,
      licensePlate,
      transportCompany,
      travelDateOnly,
      travelTimeOnly,
      isEdit,
    } = this.state;
    const t = translations[this.props.lang] || translations["EN"];
    if (!licensePlate || !transportCompany || manifestDetails.length === 0)
      return ToastStore.warning(t["Required fields missing"]);

    this.setState({ loading: true });
    const payload = {
      reservation: {
        reservationId,
        reservationNumber,
        licensePlate,
        transportCompany,
        travelDate: `${travelDateOnly} ${travelTimeOnly}`,
        status: isEdit ? this.props.listData.status : "CREATED",
      },
      passengers: manifestDetails,
      credentials: this.props.credentials,
    };

    axios
      .post(B2B_PROXY + (isEdit ? "/editBGR" : "/createBGR"), payload)
      .then(() => {
        this.setState({ loading: false });
        ToastStore.success(t["Reservation saved successfully"]);
        this.props.onSuccess();
        this.props.onClose();
      })
      .catch(() => {
        this.setState({ loading: false });
        ToastStore.error(t["Error saving reservation"]);
      });
  };

  render() {
    const { visible, onClose, lang, canCreate, canUseMRZ } = this.props;
    const {
      pcsReservation,
      transportCompany,
      travelDateOnly,
      travelTimeOnly,
      licensePlate,
      manifestDetails,
      passengerInput,
      loading,
      Countries,
      isView,
      isEdit,
      scannedSuccessfully,
    } = this.state;
    const t = translations[lang] || translations["EN"];
    const isButtonDisabled = loading || manifestDetails.length === 0;
    const today = moment().format("YYYY-MM-DD");

    // Only allow saving if user is editing OR creating with permission
    const allowSaveAction = !isView && (isEdit || canCreate);

    return (
      <Modal
        open={visible}
        onClose={onClose}
        center
        styles={{ modal: { minWidth: "90%" } }}
      >
        <div
          className="HeaderTicks"
          style={{
            backgroundColor: "#204385",
            color: "white",
            padding: "10px",
            textAlign: "center",
          }}
        >
          {isView
            ? t["View Bus Reservation"]
            : isEdit
            ? t["Edit Bus Reservation"]
            : t["Create Bus Reservation"]}
        </div>
        <div style={{ padding: "20px" }}>
          <h5>{t["Reservation Details"]}:</h5>
          <Row>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  {t["License Plate"]} <span style={{ color: "red" }}>*</span>
                </ControlLabel>
                <FormControl
                  type="text"
                  disabled={isView}
                  value={licensePlate}
                  onChange={(e) =>
                    this.setState({ licensePlate: e.target.value })
                  }
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  {t["Transport Company"]}{" "}
                  <span style={{ color: "red" }}>*</span>
                </ControlLabel>
                <FormControl
                  type="text"
                  disabled={isView}
                  value={transportCompany}
                  onChange={(e) =>
                    this.setState({ transportCompany: e.target.value })
                  }
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>{t["Travel Date"]}</ControlLabel>
                <div style={{ display: "flex", gap: "5px" }}>
                  <FormControl
                    type="date"
                    disabled={isView}
                    min={today}
                    value={travelDateOnly}
                    onChange={(e) =>
                      this.setState({ travelDateOnly: e.target.value })
                    }
                  />
                  <FormControl
                    type="time"
                    disabled={isView}
                    value={travelTimeOnly}
                    onChange={(e) =>
                      this.setState({ travelTimeOnly: e.target.value })
                    }
                    style={{ width: "240px" }}
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>{t["PCS Reservation"]}</ControlLabel>
                <FormControl
                  type="text"
                  disabled={isView}
                  value={pcsReservation}
                  onChange={(e) =>
                    this.setState({ pcsReservation: e.target.value })
                  }
                />
              </FormGroup>
            </Col>
          </Row>

          <PassengerDetailsPlaceholder
            t={t}
            isView={isView}
            canCreate={canCreate}
            details={manifestDetails}
            passengerInput={passengerInput}
            Countries={Countries}
            onInputChange={this.handlePassengerInputChange}
            onAddPassenger={this.handleAddPassenger}
            onRemove={this.onRemove}
            onEditPassenger={this.handleEditPassenger}
            canUseMRZ={canUseMRZ}
            scannedSuccessfully={scannedSuccessfully}
          />

          <Row style={{ marginTop: "20px", display: "flex", alignItems: "center", flexWrap: "wrap" }}>
            {!allowSaveAction ? (
              <Col md={12} className="text-center">
                <Button
                  bsStyle="primary"
                  onClick={onClose}
                  style={{ width: "150px" }}
                >
                  {t["Close"]}
                </Button>
              </Col>
            ) : (
              <React.Fragment>
                <Col md={3}>
                  {canUseMRZ && (
                    <div style={{ 
                      padding: '6px 12px', 
                      borderRadius: '4px', 
                      background: this.props.port ? 'rgba(46, 204, 113, 0.1)' : 'rgba(231, 76, 60, 0.1)',
                      border: this.props.port ? '1px solid #2ecc71' : '1px solid #e74c3c',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '46px',
                      width: '100%',
                      boxSizing: 'border-box',
                      alignSelf: 'center',
                      marginBottom: '10px'
                    }}>
                      <span style={{ 
                        color: this.props.port ? '#2ecc71' : '#e74c3c', 
                        fontWeight: 'bold',
                        fontSize: '14px'
                      }}>
                        {this.props.port ? '✓ Scanner Ready' : '✕ Scanner Disconnected'}
                      </span>
                    </div>
                  )}
                </Col>
                <Col md={6}></Col>
                <Col md={3}>
                  <Button
                    bsStyle="primary"
                    block
                    onClick={() => this.processSave()}
                    disabled={isButtonDisabled}
                  >
                    {isEdit ? t["Save Changes BGR"] : t["Save BGR"]}
                  </Button>
                </Col>
              </React.Fragment>
            )}
          </Row>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bgrComponents/BGRCreateEditModal.js